import React, { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';
// import { useSelector } from 'react-redux';
import { Getstates } from '../../../../Axios/ServiceApi';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
  Box,
  Button,
  // Checkbox,
  // Divider,
  FormControl,
  // FormControlLabel,
  FormHelperText,
  Grid,
  Alert,
  Snackbar,
  // InputAdornment,
  InputLabel,
  OutlinedInput

  // TextField,
  // Typography,
  // useMediaQuery
} from '@mui/material';

// third party
import * as Yup from 'yup';
import { Formik } from 'formik';

// project imports
import useScriptRef from 'hooks/useScriptRef';
// import Upload from 'assets/images/Image upload-bro.svg';
// import Google from 'assets/images/icons/social-google.svg';
import AnimateButton from 'ui-component/extended/AnimateButton';
import { Stack } from '@mui/system';
import { BankAccNumberVerify } from '../../../../Axios/BankVerify';
import { GetBankDetails, GetIfscDetails, postOnlineTransferData } from '../../../../Axios/LimitAccountRegistration';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { getProfileDetailsOnce } from '../../../../Axios/Profile';

// import Radio from '@mui/material/Radio';
// import RadioGroup from '@mui/material/RadioGroup';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import FormLabel from '@mui/material/FormLabel';
// import { IconUserPlus } from '@tabler/icons';
// import { Image } from '@mui/icons-material';
// import { strengthColor, strengthIndicator } from 'utils/password-strength';

// assets
// import Visibility from '@mui/icons-material/Visibility';
// import VisibilityOff from '@mui/icons-material/VisibilityOff';

// ===========================|| FIREBASE - REGISTER ||=========================== //

const OnlineRegister = () => {
  const theme = useTheme();
  const scriptedRef = useScriptRef();
  const [Verified, setVerified] = useState(false);
  const [VerifyResponse, setVerifyResponse] = useState(null);
  const [BankList, setBankList] = useState(null);
  const [userDetails, setUserDetails] = useState(null);

  const [stateList, setStateList] = useState(null);
  useEffect(() => {
    Getstates(setStateList);
    GetBankDetails(setBankList);
    getProfileDetailsOnce(setUserDetails);
  }, []);

  console.log('States ', stateList);

  console.log('BankList', BankList);

  const [ErrOpen, setErrOpen] = useState(false);
  const [AlerType, setAlertType] = useState('success');
  const [AlertMessage, setAlertMessage] = useState(null);
  const [openLoader, setOpenLoader] = useState(false);
  const [ifscData, setIfscData] = useState(null);

  const handleErrClose = () => {
    setErrOpen(false);
  };

  const handleIfscCheck = (ifsc, setFieldValue) => {
    GetIfscDetails(ifsc, setIfscData, setFieldValue);
  };

  console.log(ifscData);

  return (
    <>
      {/*  */}
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={openLoader}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar open={ErrOpen} autoHideDuration={5000} onClose={handleErrClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <Alert onClose={handleErrClose} variant="filled" severity={AlerType} sx={{ width: '100%' }}>
          {AlertMessage}
        </Alert>
      </Snackbar>

      {/*  */}
      {userDetails ? (
        <Formik
          initialValues={{
            agent_code: sessionStorage.getItem('user_code') ? sessionStorage.getItem('user_code') : '',
            holder_name: userDetails ? userDetails.first_name + ' ' + userDetails.last_name : '',
            bank_name: '',
            account_number: '',
            ifsc_code: ''
            // submit: null
          }}
          validationSchema={Yup.object().shape({
            agent_code: Yup.string().max(255).required('Agent code is required'),
            holder_name: Yup.string().required('Account holder name is required'),
            bank_name: Yup.string().required('Bank name is required'),
            account_number: Yup.string().required('Account number is required'),
            ifsc_code: Yup.string().required('Ifsc code is required')
          })}
          onSubmit={async (values, { setErrors, setStatus, setSubmitting, setFieldValue }) => {
            try {
              if (scriptedRef.current) {
                if (!Verified && !VerifyResponse) {
                  BankAccNumberVerify(
                    values.ifsc_code,
                    values.account_number,
                    setAlertMessage,
                    setErrOpen,
                    setVerified,
                    setAlertType,
                    setOpenLoader,
                    setVerifyResponse
                  );
                } else {
                  postOnlineTransferData(values, setAlertMessage, setErrOpen, setAlertType, setFieldValue, setOpenLoader);
                }
              }
            } catch (err) {
              console.error('error ', err);
              if (scriptedRef.current) {
                setStatus({ success: false });
                setErrors({ submit: err.message });
                setSubmitting(false);
              }
            }
          }}
        >
          {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values, isValid, setFieldValue }) => (
            <form noValidate onSubmit={handleSubmit}>
              <Stack direction={{ xs: 'column', xl: 'row', lg: 'row', md: 'row', sm: 'row' }}>
                {/* <MapModal change={change} setChange={setChange} open={open} handleClose={handleClose} /> */}
                <Grid item xs={12} sm={12}>
                  <Grid container spacing={1}>
                    <Grid item xl={6}>
                      <FormControl
                        fullWidth
                        error={Boolean(touched.agent_code && errors.agent_code)}
                        sx={{ ...theme.typography.customInput }}
                      >
                        <InputLabel htmlFor="outlined-adornment-email-register">Agent code</InputLabel>
                        <OutlinedInput
                          id="outlined-adornment-email-register"
                          type="text"
                          value={values.agent_code}
                           name="agent_code"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          inputProps={{readOnly:true}}
                        />
                        {touched.agent_code && errors.agent_code && (
                          <FormHelperText error id="standard-weight-helper-text-address-register">
                            {errors.agent_code}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} lg={6} md={6} sm={6}>
                      <FormControl
                        fullWidth
                        error={Boolean(touched.holder_name && errors.holder_name)}
                        sx={{ ...theme.typography.customInput }}
                      >
                        <InputLabel htmlFor="outlined-adornment-pincode-register">Account Holder name</InputLabel>
                        <OutlinedInput
                          id="outlined-adornment-pincode-register"
                          type="text"
                           value={values.holder_name}
                          name="holder_name"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          inputProps={{readOnly:true}}
                        />
                        {touched.holder_name && errors.holder_name && (
                          <FormHelperText error id="standard-weight-helper-text-pincode-register">
                            {errors.holder_name}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} lg={6} md={6} sm={6}>
                      <FormControl fullWidth error={Boolean(touched.ifsc && errors.ifsc)} sx={{ ...theme.typography.customInput }}>
                        <InputLabel htmlFor="outlined-adornment-pincode-register">IFSC Code</InputLabel>
                        <OutlinedInput
                          id="outlined-adornment-pincode-register"
                          type="text"
                          value={values.ifsc_code}
                          name="ifsc_code"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          inputProps={{}}
                          endAdornment={
                            <Button
                              component="label"
                              sx={{ backgroundColor: '#A556B2', '&:hover': { backgroundColor: '#A556B2' } }}
                              variant="contained"
                              onClick={values.ifsc_code ? () => handleIfscCheck(values.ifsc_code, setFieldValue) : null}
                            >
                              Check
                            </Button>
                          }
                        />
                        {touched.ifsc && errors.ifsc && (
                          <FormHelperText error id="standard-weight-helper-text-pincode-register">
                            {errors.ifsc}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} lg={6} md={6} sm={6}>
                      <FormControl
                        fullWidth
                        error={Boolean(touched.bank_name && errors.bank_name)}
                        sx={{ ...theme.typography.customInput }}
                      >
                        <InputLabel htmlFor="outlined-adornment-pincode-register">Bank Name</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={values.bank_name}
                          label="Bank Name"
                          name="bank_name"
                          sx={{ padding: '5px' }}
                          onChange={handleChange}
                        >
                          {BankList &&
                            BankList.map((item, index) => {
                              return (
                                <MenuItem value={item} key={index}>
                                  {item}
                                </MenuItem>
                              );
                            })}
                        </Select>
                        {touched.bank_name && errors.bank_name && (
                          <FormHelperText error id="standard-weight-helper-text-pincode-register">
                            {errors.bank_name}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} lg={6} md={6} sm={6}>
                      <FormControl
                        fullWidth
                        error={Boolean(touched.account_number && errors.account_number)}
                        sx={{ ...theme.typography.customInput }}
                      >
                        <InputLabel htmlFor="outlined-adornment-pincode-register">Account Number</InputLabel>
                        <OutlinedInput
                          id="outlined-adornment-pincode-register"
                          type="text"
                          value={values.account_number}
                          name="account_number"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          inputProps={{}}
                        />
                        {touched.account_number && errors.account_number && (
                          <FormHelperText error id="standard-weight-helper-text-pincode-register">
                            {errors.account_number}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Grid>
                  </Grid>

                  {errors.submit && (
                    <Box sx={{ mt: 3 }}>
                      <FormHelperText error>{errors.submit}</FormHelperText>
                    </Box>
                  )}
                </Grid>
              </Stack>
              <Grid container spacing={4}>
                <Grid item sm={6} xs={6}>
                  <Box sx={{ mt: 2 }}>
                    <AnimateButton>
                      <Button
                        disableElevation
                        disabled={isSubmitting || !isValid}
                        fullWidth
                        size="large"
                        type="submit"
                        variant="contained"
                        sx={{ backgroundColor: Verified ? 'green' : '#A556B2', color: '#fff', '&:hover': { backgroundColor: '#A556B2' } }}
                      >
                        {console.log(errors)}
                        {!Verified ? 'Verify' : 'Submit'}
                      </Button>
                    </AnimateButton>
                  </Box>
                </Grid>
              </Grid>
            </form>
          )}
        </Formik>
      ) : (
        <Stack justifyContent="center" alignItems="center" height="30vh">
          <CircularProgress color="inherit" />
        </Stack>
      )}

      {/* image upload Dialog start */}
    </>
  );
};

export default OnlineRegister;
